import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Breadcrumbs from '../../components/Category/Breadcrumbs';
import ListSD from '../../components/Category/ListSD';
import RangeSlide from '../../components/Elements/RangeSlide/RangeSlide';
import Pagination from '../Pagination/Pagination';
import { updateFilter, resetFilter, clearFilter, updatePagination } from '../../actions/environment';
import { intersect, unique, difference } from '../../utils/array';
import { fixBackgroundScroll, hasClass, addEvent, removeEvent, height } from '../../utils/dom';
import { translate, prefix } from '../../utils/locale';
import { deepCompare } from '../../utils/object';
import { pascalCase, lowContrast } from '../../utils/string';
import s from './Filter.scss';

class Filter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			filterOpen: false,
			filterHeight: 0,
			sortOpen: false,
			sortHeight: 0,
			sizes: false,
			colors: false,
			materials: false,
			features: false,
			collections: false,
			prices: false,
			sort: false,
			gridAmount: '4',
			showingGhost: false,
			screenHeight: typeof window !== 'undefined' ? `${window.innerHeight - 78}px` : 'none',
			hash: typeof window !== 'undefined' ? window.location.hash : '',
		};

		this.filterTools = React.createRef();
		this.sortContainer = React.createRef();
		this.filterContainer = React.createRef();
	}

	componentDidMount() {
		if (this.state.hash) {
			const hashFilter = [];
			this.state.hash.slice(1).split('&').forEach((filterPart) => {
				const filterParts = filterPart.split('=');
				if (filterParts.length === 1) {
					hashFilter.push({ [filterParts[0]]: true });
				} else {
					hashFilter.push({ [filterParts[0]]: filterParts[1].split(',') });
				}
			});

			this.props.updateFilter(hashFilter, true, this.props.setup, this.props.currentPath);
			this.setState({ hash: null });
		}

		const updateWindowHeight = () => {
			this.setState({ screenHeight: `${window.innerHeight - 78}px` });
		};

		addEvent(window, 'resize.toolbar', () => {
			window.requestAnimationFrame(updateWindowHeight);
		});

		addEvent(window, 'scroll.toolbar', () => {
			window.requestAnimationFrame(updateWindowHeight);
		});
	}

	componentWillUnmount() {
		fixBackgroundScroll(false);
		removeEvent(window, 'resize.toolbar');
		removeEvent(window, 'scroll.toolbar');
	}

	handleToggleDropdown = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;

		if ($link.getAttribute('href') === '#open-filter') {
			this.setState((prevState) => {
				if (prevState.filterOpen) {
					window.setTimeout(() => {
						this.setState({
							sizes: false,
							colors: false,
							materials: false,
							features: false,
							collections: false,
							prices: false,
						});
					}, 700);
				}
				fixBackgroundScroll(!prevState.filterOpen);

				let filterHeight = 0;
				let sortHeight = 0;
				if (!prevState.filterOpen) {
					filterHeight = height(this.filterContainer.current, 'scrollHeight');
					setTimeout(() => {
						this.setState({ filterHeight: 'auto' });
					}, 500);
					if (prevState.sortOpen) {
						sortHeight = height(this.sortContainer.current, 'scrollHeight');
						setTimeout(() => {
							this.setState({ sortHeight: 0 });
						}, 200);
					}
				} else {
					filterHeight = height(this.filterContainer.current, 'scrollHeight');
					setTimeout(() => {
						this.setState({ filterHeight: 0 });
					}, 200);
				}

				return {
					filterOpen: !prevState.filterOpen,
					filterHeight,
					sortOpen: false,
					sortHeight,
					screenHeight: `${window.innerHeight - 78}px`,
				};
			});
		} else if ($link.getAttribute('href') === '#open-sort') {
			this.setState((prevState) => {
				fixBackgroundScroll(!prevState.sortOpen);

				let sortHeight = 0;
				let filterHeight = 0;
				if (!prevState.sortOpen) {
					sortHeight = height(this.sortContainer.current, 'scrollHeight');
					setTimeout(() => {
						this.setState({ sortHeight: 'auto' });
					}, 500);
					if (prevState.filterOpen) {
						filterHeight = height(this.filterContainer.current, 'scrollHeight');
						setTimeout(() => {
							this.setState({ filterHeight: 0 });
						}, 200);
					}
				} else {
					sortHeight = height(this.sortContainer.current, 'scrollHeight');
					setTimeout(() => {
						this.setState({ sortHeight: 0 });
					}, 200);
				}

				return {
					sortOpen: !prevState.sortOpen,
					sortHeight,
					filterOpen: false,
					filterHeight,
					screenHeight: `${window.innerHeight - 78}px`,
				};
			});
		} else {
			fixBackgroundScroll(false);
			this.setState({
				sortOpen: false,
				sortHeight: 0,
				filterOpen: false,
				filterHeight: 0,
			});
		}
	}

	handleClearFilter = (e) => {
		e.preventDefault();
		this.props.clearFilter();
		this.props.updatePagination(this.props.currentPath, 1);
		this.resetFilterDropdowns();
	}

	resetFilterDropdowns = (e) => {
		if (e) e.preventDefault();
		this.setState((prevState) => {
			let sortHeight = 0;
			if (prevState.sortOpen) {
				sortHeight = height(this.sortContainer.current, 'scrollHeight');
				setTimeout(() => {
					this.setState({ sortHeight: 0 });
				}, 200);
			}

			let filterHeight = 0;
			if (prevState.filterOpen) {
				filterHeight = height(this.filterContainer.current, 'scrollHeight');
				setTimeout(() => {
					this.setState({ filterHeight: 0 });
				}, 200);
			}

			return {
				sizes: false,
				colors: false,
				materials: false,
				features: false,
				collections: false,
				prices: false,
				sort: false,
				sortOpen: false,
				sortHeight,
				filterOpen: false,
				filterHeight,
			};
		});
		fixBackgroundScroll(false);
		if (window.innerWidth <= 600) {
			window.scrollTo(0, 0);
		}
	}

	handleToggleGroup = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;
		const whichGroup = $link.dataset.group;
		const nextState = {
			sizes: false,
			colors: false,
			materials: false,
			features: false,
			collections: false,
			prices: false,
			sort: false,
			screenHeight: `${window.innerHeight - 78}px`,
		};

		this.setState((prevState) => {
			if (!prevState[whichGroup]) nextState[whichGroup] = true;
			return nextState;
		});
	}

	handleFilterUpdate = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;
		const action = $link.getAttribute('href');
		const filterType = action.indexOf('#') === 0 ? action.slice(1, action.indexOf('=')) : 'categories';
		const filterValue = action.indexOf('#') === 0 ? action.slice(action.indexOf('=') + 1) : action.replace(prefix(this.props.setup, ''), '');

		this.props.updateFilter([{ [filterType]: filterValue }], false, this.props.setup, this.props.currentPath);
		this.props.updatePagination(this.props.currentPath, 1);

		if (hasClass(document.body, 'u_backgroundFixed')) document.body.style.top = '0px';

		if (filterType === 'sort') {
			this.setState({
				sortOpen: false,
				filterOpen: false,
				sortHeight: height(this.sortContainer.current, 'scrollHeight'),
				filterHeight: height(this.sortContainer.current, 'scrollHeight'),
			});
			setTimeout(() => {
				this.setState({ sortHeight: 0 });
				this.setState({ filterHeight: 0 });
			}, 200);
			fixBackgroundScroll(false);
		}
	}

	priceSlideHandler = ([lower, upper]) => {
		this.props.updateFilter([{ price: [lower, upper] }], false, this.props.setup, this.props.currentPath);
		this.props.updatePagination(this.props.currentPath, 1);
	}

	toggleGhostHandler = (e) => {
		const showingGhost = parseInt(e.currentTarget.value, 10) > 0;
		this.setState({ showingGhost });
	}

	changeGridHandler = (e) => {
		const gridAmount = e.currentTarget.value;
		this.setState({ gridAmount });
	}

	render() {
		const { ListComponent, data = {}, filtering, setup, filter, currentPath, list, contentSections, contentOffset, closeSearch, showSale } = this.props;
		const { filterOpen, filterHeight, sortOpen, sortHeight, screenHeight, gridAmount, showingGhost } = this.state;

		// how to update filterHash on page load???

		const { filterArrays, filterDescriptions, localized, products } = filtering;
		const isLocalized = localized[setup.language];
		const isFiltered = filter.filteredBy.filter((f) => !f.categories && !f.productsOnSale && f.productsOnSale === true).length > 0 || !!filter.sort;

		if (!filter.currentFilterSegment && currentPath !== 'search') return null;

		// Category paths are localized.
		const categories = isLocalized ? Object.keys(filterArrays.categories).reduce((acc, category) => {
			const categoryKey = isLocalized.categories[category] ? isLocalized.categories[category].key : category;
			return ({ ...acc, [categoryKey]: [...filterArrays.categories[category]] });
		}, {}) : filterArrays.categories;

		// Localize colors
		const colors = isLocalized ? Object.keys(filterArrays.colors).reduce((acc, color) => {
			const colorkey = isLocalized.colors[color] ? isLocalized.colors[color].key : color;
			return ({ ...acc, [colorkey]: [...filterArrays.colors[color]] });
		}, {}) : filterArrays.colors;

		const colorDescriptions = isLocalized ? Object.keys(filterArrays.colors).reduce((acc, color) => {
			const colorKey = isLocalized.colors[color] ? isLocalized.colors[color].key : color;
			const colorDescription = isLocalized.colors[color] ? isLocalized.colors[color].description : filterDescriptions.colors[color];
			return ({ ...acc, [colorKey]: colorDescription });
		}, {}) : filterDescriptions.colors;

		// Localize materials
		const materials = isLocalized ? Object.keys(filterArrays.materials).reduce((acc, material) => {
			const materialkey = isLocalized.materials[material] ? isLocalized.materials[material].key : material;
			return ({ ...acc, [materialkey]: [...filterArrays.materials[material]] });
		}, {}) : filterArrays.materials;

		const materialDescriptions = isLocalized ? Object.keys(filterArrays.materials).reduce((acc, material) => {
			const materialKey = isLocalized.materials[material] ? isLocalized.materials[material].key : material;
			const materialDescription = isLocalized.materials[material] ? isLocalized.materials[material].title : filterDescriptions.materials[material];
			return ({ ...acc, [materialKey]: materialDescription });
		}, {}) : filterDescriptions.materials;

		// Localize features
		const features = isLocalized ? Object.keys(filterArrays.features).reduce((acc, feature) => {
			const featurekey = isLocalized.features[feature] ? isLocalized.features[feature].key : feature;
			return ({ ...acc, [featurekey]: [...filterArrays.features[feature]] });
		}, {}) : filterArrays.features;

		const featureDescriptions = isLocalized ? Object.keys(filterArrays.features).reduce((acc, feature) => {
			const featureKey = isLocalized.features[feature] ? isLocalized.features[feature].key : feature;
			const featureDescription = isLocalized.features[feature] ? isLocalized.features[feature].title : filterDescriptions.features[feature];
			return ({ ...acc, [featureKey]: featureDescription });
		}, {}) : filterDescriptions.features;

		// Localize collections
		const collections = isLocalized ? Object.keys(filterArrays.collections).reduce((acc, collection) => {
			const collectionkey = isLocalized.collections[collection] ? isLocalized.collections[collection].key : collection;
			return ({ ...acc, [collectionkey]: [...filterArrays.collections[collection]] });
		}, {}) : filterArrays.collections;

		const collectionDescriptions = isLocalized ? Object.keys(filterArrays.collections).reduce((acc, collection) => {
			const collectionKey = isLocalized.collections[collection] ? isLocalized.collections[collection].key : collection;
			const collectionDescription = isLocalized.collections[collection] ? isLocalized.collections[collection].title : filterDescriptions.collections[collection];
			return ({ ...acc, [collectionKey]: collectionDescription });
		}, {}) : filterDescriptions.collections;

		/*
			Filter

			This could benefit from memoization - reselect

			Filters which don't match the base list of products are removed i.e. women men etc.
			Filters which don't match the current categories' list of products are disabled. Except categories.
		*/

		// Get base URI for filtering.
		if (typeof data.baseUri === 'undefined' && currentPath !== 'search') return null;
		let relevantBaseProducts = filterArrays[data.baseType]?.[currentPath] || filterArrays[data.baseType]?.[data.baseUri] || [];
		if (data.baseType === 'campaigns') relevantBaseProducts = filterArrays[data.campaignType];
		if (currentPath === 'search') relevantBaseProducts = list;
		relevantBaseProducts = relevantBaseProducts.filter((rbp) => {
			if (typeof products[rbp] === 'undefined') return false;
			if (products[rbp]?.productStatus_discontinued && !products[rbp]?.productStatus_limitedEdition && parseInt((products[rbp].inStock || 0), 10) === 0) return false; // eslint-disable-line camelcase
			return true;
		});
		let relevantProducts = [...relevantBaseProducts];

		const currentPrices = relevantProducts.map((cacheID) => products?.[cacheID]?.price?.priceAsNumber).sort((a, b) => (parseInt(a, 10) > parseInt(b, 10) ? 1 : -1));
		const priceMedians = [[25, ''], [50, setup.currency === 'USD' ? '$$' : '€€'], [75, '']];

		const filteredProducts = {};
		let hideSaleToggle = false;

		// Filter only relevant products
		filter.filteredBy.forEach((filterObj) => {
			const filterType = Object.keys(filterObj)[0];
			const filterItem = filterObj[filterType];
			if (filterItem === true || (Array.isArray(filterItem) && filterItem.length > 0)) {
				// Products are filtered
				// Need to update relevantProducts on every pass.
				switch (filterType) {
					case 'categories': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...(categories[type] ? categories[type] : []), ...acc], []));
						filteredProducts.categories = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'colors': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...colors[type], ...acc], []));
						filteredProducts.colors = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'sizes': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...filterArrays.sizes[type.slice(0, type.lastIndexOf('___'))][type.slice(type.lastIndexOf('___') + 3)], ...acc], []));
						filteredProducts.sizes = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'materials': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...materials[type], ...acc], []));
						filteredProducts.materials = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'features': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...features[type], ...acc], []));
						filteredProducts.features = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'collections': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...collections[type], ...acc], []));
						filteredProducts.collections = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'productsOnSale': {
						// If the filter is set to hide show sale products, we need to remove the productsOnSale from the relevantProducts.
						const onSaleItems = unique(filterArrays.productsOnSale);
						filteredProducts.productsOnSale = onSaleItems;
						const tempRelevantProducts = difference(relevantProducts, onSaleItems);
						if (tempRelevantProducts.length > 6 && currentPath.indexOf('sale') === -1 && currentPath !== 'search') {
							relevantProducts = tempRelevantProducts;
						} else {
							// We're now forcing showing sale products due to above requirements
							// And removing the ability to hide them due to small amounts of products being shown.
							hideSaleToggle = true;
						}
						break;
					}
					case 'price': {
						const lowerAmount = parseInt(currentPrices[Math.floor((currentPrices.length - 1) * (parseInt(filterItem[0], 10) / 100))], 10);
						const upperAmount = parseInt(currentPrices[Math.floor((currentPrices.length - 1) * (parseInt(filterItem[1], 10) / 100))], 10);
						const concatenatedItems = relevantProducts.filter((item) => {
							const price = parseInt(products[item].price.priceAsNumber, 10);
							return price >= lowerAmount && price <= upperAmount;
						});
						filteredProducts.price = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					default:
						break;
				}
			}
		});

		// Last filter is special so that the user can select multiple filters.
		let relevantFilterProducts = [...relevantBaseProducts];
		let relevantFilterProductsLast = [...relevantBaseProducts];
		let lastFilter = '';

		if (Object.keys(filteredProducts).length > 0) {
			// Restrict filters based on final filter in filteredBy.
			filter.filteredBy.slice(0).forEach((filterObj, i) => {
				lastFilter = Object.keys(filterObj)[0];
				if (filteredProducts[lastFilter]) {
					relevantFilterProducts = intersect(relevantFilterProducts, filteredProducts[lastFilter]);
					if (i < filter.filteredBy.length - 1) relevantFilterProductsLast = intersect(relevantFilterProductsLast, filteredProducts[lastFilter]);
				}
			});
		}

		/*
			Sorting
		*/
		if (filter.sort) {
			const sortBy = filter.sort.replace(/-(ascending|descending)$/, '');

			relevantProducts = relevantProducts.map((productId) => {
				let sortingValue = filter.sort.indexOf('descending') !== -1 ? 0 : 9999999999;

				if (sortBy === 'price') {
					sortingValue = products[productId].price.priceAsNumber;
				} else if (products[productId][sortBy]) {
					sortingValue = products[productId][sortBy];
					sortingValue = String(sortingValue);
				}

				return { key: productId, sort: sortingValue };
			}).sort((a, b) => {
				if (sortBy === 'price') {
					if (a.sort === b.sort) return parseInt(a.key, 10) > parseInt(b.key, 10) ? 1 : -1;
					if (filter.sort.indexOf('descending') === -1) {
						return a.sort > b.sort ? 1 : -1;
					}
					return a.sort < b.sort ? 1 : -1;
				}
				if (filter.sort.indexOf('descending') === -1) {
					return a.sort.localeCompare(b.sort);
				}
				return b.sort.localeCompare(a.sort);
			}).map((productObject) => productObject.key);
		}

		const saleClasses = [s.section_group_item, s.section_group_item__boolean];
		if (intersect(filterArrays.productsOnSale, (lastFilter === 'productsOnSale' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) saleClasses.push(s.section_group_item__disabled);
		if (!filter.productsOnSale) saleClasses.push(s.section_group_item__selected);

		return (
			<div className={[s.filter, currentPath === 'search' ? s.filter__search : null].join(' ')}>
				{ currentPath !== 'search' && <ListSD meta={data?.content || {}} list={relevantProducts.map((productId) => products[productId])} setup={setup} /> }
				{ (sortOpen || filterOpen) && <button className={s.filter_screen} onClick={this.handleToggleDropdown} type="button" aria-label="Close Filter Tools" /> }
				<div className={[s.filter_tools, (sortOpen || filterOpen ? s.filter_tools__open : null), (relevantBaseProducts.length === 0 ? s.filter_tools__empty : null)].join(' ')} ref={this.filterTools}>
					<div className={s.filter_tools_breadcrumbs}>
						<Breadcrumbs />
					</div>
					<div className={s.filter_tools_view}>
						{
							data.baseType === 'categories' && ['women', 'men', 'lee-x-stutterheim-collection'].indexOf(String(data.baseUri)) !== -1 && (
								<div className={s.ghostSwitcher}>
									<button className={[s.ghostSwitcher_button, !showingGhost ? s.ghostSwitcher_button__selected : null].join(' ')} type="button" onClick={this.toggleGhostHandler} value="0" aria-label="Switch to model with product"><span>{ translate(setup, 'filterSetModel') }</span></button>
									<button className={[s.ghostSwitcher_button, showingGhost ? s.ghostSwitcher_button__selected : null].join(' ')} type="button" onClick={this.toggleGhostHandler} value="1" aria-label="Switch to product only"><span>{ translate(setup, 'filterSetGhost') }</span></button>
								</div>
							)
						}
						<div className={[s.gridSwitcher, (gridAmount === '3' ? s.gridSwitcher__isSet : null)].join(' ')}>
							<span className={s.gridSwitcher_title}>{ translate(setup, 'filterGridView') }</span>
							<button className={[s.gridSwitcher_button, gridAmount === '3' ? s.gridSwitcher_button__selected : null].join(' ')} type="button" onClick={this.changeGridHandler} value="3" aria-label="Switch to 3 per row"><span /><span /><span /></button>
							<button className={[s.gridSwitcher_button, gridAmount === '4' ? s.gridSwitcher_button__selected : null].join(' ')} type="button" onClick={this.changeGridHandler} value="4" aria-label="Switch to 4 per row"><span /><span /><span /><span /></button>
						</div>
						{/* Sort */}
						<div className={[s.filtering, s.filtering__sort, (filter.sort ? s.filtering__isSet : null), (sortOpen ? s.filtering__open : null)].join(' ')}>
							<div className={s.filtering_title}>
								<a href="#open-sort" onClick={this.handleToggleDropdown}>
									{ translate(setup, 'sortOpen') }
									<div className={s.filtering_title_chosenItems}>
										{
											filter.sort && (
												<span className={s.filtering_title_chosenItem}>
													{ filter.sort.indexOf('price') !== -1 && `$ ${filter.sort.indexOf('ascending') !== -1 ? '→' : '←'} ¢` }
													{ filter.sort.indexOf('name') !== -1 && `A ${filter.sort.indexOf('ascending') !== -1 ? '→' : '←'} Z` }
													{ filter.sort.indexOf('name') === -1 && filter.sort.indexOf('price') === -1 && translate(setup, `filterSort${pascalCase(filter.sort)}`) }
												</span>
											)
										}
									</div>
									<svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M8.07013 1.75472L6.27349 3.12736L5.34555 3.87734L4.19705 3.12729V3.11321L2.42987 1.75472L0 0V2.1934L5.24264 6L10.5 2.1934V0L8.07013 1.75472Z" fill="black" />
									</svg>
								</a>
							</div>
							<div ref={this.sortContainer} className={s.filtering_inner} style={{ maxHeight: screenHeight, height: sortHeight }}>

								<div className={s.section}>
									<div className={[s.section_group, s.section_group__open].join(' ')}>
										<span className={s.section_group_title} />

										{/* sorts */}
										<div className={[s.section_group_items, s.section_group_items__standard, s.section_group_items__sort].join(' ')}>
											<div className={[s.section_group_item, (filter.sort === '' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=">{ translate(setup, 'filterSortRecommended') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'added-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=added-descending">{ translate(setup, 'filterSortAddedDescending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'price-ascending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=price-ascending">{ translate(setup, 'filterSortPriceAscending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'price-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=price-descending">{ translate(setup, 'filterSortPriceDescending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'name-ascending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=name-ascending">{ translate(setup, 'filterSortAlphabetAscending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'name-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=name-descending">{ translate(setup, 'filterSortAlphabetDescending') }</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* Filter */}
						<div className={[s.filtering, s.filtering__filter, (isFiltered ? s.filtering__isSet : null), (filterOpen ? s.filtering__open : null)].join(' ')}>
							<div className={s.filtering_title}>
								<a href="#open-filter" onClick={this.handleToggleDropdown}>
									{ setup.breakPoint === 'mobile' ? `${translate(setup, 'filterSort').replace(/\s.*$/, '')} / ${translate(setup, 'filterOpen')}` : translate(setup, 'filterOpen') }
									<div className={s.filtering_title_chosenItems}>
										{
											filter.filteredBy.slice(1).map((fB) => {
												const [filterCategoryValue] = Object.keys(fB);

												const filterCategory = filterDescriptions[filterCategoryValue];
												if (filterCategoryValue === 'colors') {
													return fB[filterCategoryValue].map((fCV) => {
														if (filterCategory[fCV].image) return <span key={`selected${filterCategoryValue}${fCV}`} className={s.filtering_title_chosenItem} style={{ backgroundImage: `url(${filterCategory[fCV].image.url})` }} />;
														return <span key={`selected${filterCategoryValue}${fCV}`} className={s.filtering_title_chosenItem} style={{ backgroundColor: filterCategory[fCV].color }} />;
													});
												}

												if (filterCategory && fB[filterCategoryValue].length > 0) {
													return fB[filterCategoryValue].map((fCV) => (
														<span key={`selected${filterCategoryValue}${fCV}`} className={s.filtering_title_chosenItem}>
															{ filterCategory[fCV.split('___').pop()] ? translate(setup, filterCategory[fCV.split('___').pop()]) : filterCategory[fCV.split('___').pop()] }
														</span>
													));
												}

												if (filterCategoryValue === 'price' && fB[filterCategoryValue].length > 0) {
													return <span key={`selected${filterCategoryValue}`} className={s.filtering_title_chosenItem}>{ `${currentPrices[Math.floor((currentPrices.length - 1) * (fB[filterCategoryValue][0] / 100))]} - ${currentPrices[Math.floor((currentPrices.length - 1) * (fB[filterCategoryValue][1] / 100))]}` }</span>;
												}

												return null;
											})
										}
									</div>
									<svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M8.07013 1.75472L6.27349 3.12736L5.34555 3.87734L4.19705 3.12729V3.11321L2.42987 1.75472L0 0V2.1934L5.24264 6L10.5 2.1934V0L8.07013 1.75472Z" fill="black" />
									</svg>
								</a>
							</div>
							<div ref={this.filterContainer} className={s.filtering_inner} style={{ maxHeight: screenHeight, height: filterHeight }}>
								{/* sort mobile */}
								<div className={[s.section, s.section__mobile].join(' ')}>
									<div className={[s.section_group, (this.state.sort ? s.section_group__open : null)].join(' ')}>
										<a className={s.section_group_title} href="#open-group" data-group="sort" onClick={this.handleToggleGroup}>
											<span>{ translate(setup, 'filterSort') }</span>
											<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
											</svg>
										</a>

										{/* sorts */}
										<div className={[s.section_group_items, s.section_group_items__standard, s.section_group_items__sort].join(' ')}>
											<div className={[s.section_group_item, (filter.sort === 'price-ascending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=price-ascending">{ translate(setup, 'filterSortPriceAscending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'price-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=price-descending">{ translate(setup, 'filterSortPriceDescending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'name-ascending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=name-ascending">{ translate(setup, 'filterSortAlphabetAscending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'name-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=name-descending">{ translate(setup, 'filterSortAlphabetDescending') }</a>
											</div>
											<div className={[s.section_group_item, (filter.sort === 'added-descending' ? [s.section_group_item__selected] : null)].join(' ')}>
												<a onClick={this.handleFilterUpdate} href="#sort=added-descending">{ translate(setup, 'filterSortAddedDescending') }</a>
											</div>
										</div>
									</div>
								</div>

								{/* sizes */}
								<div className={s.section}>
									<div className={[s.section_group, (this.state.sizes ? s.section_group__open : null)].join(' ')}>
										<a className={s.section_group_title} href="#open-group" data-group="sizes" onClick={this.handleToggleGroup}>
											<span>{ translate(setup, 'filterSize') }</span>
											<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
											</svg>
										</a>
										{
											Object.keys(filterArrays.sizes).map((sizeGroup) => {
												const links = [];

												Object.keys(filterArrays.sizes[sizeGroup]).forEach((size) => {
													if (intersect(filterArrays.sizes[sizeGroup][size], relevantBaseProducts).length === 0) return;

													const linkClasses = [s.section_group_item];
													if (intersect(filterArrays.sizes[sizeGroup][size], (lastFilter === 'sizes' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) {
														linkClasses.push(s.section_group_item__disabled);
													}
													if (filter.sizes.indexOf(`${sizeGroup}___${size}`) !== -1) linkClasses.push(s.section_group_item__selected);

													links.push((
														<a key={`${sizeGroup}___${size}`} className={linkClasses.join(' ')} onClick={this.handleFilterUpdate} href={`#sizes=${sizeGroup}___${size}`}>
															<span>{ filterDescriptions.sizes[size] }</span>
														</a>
													));
												});

												if (links.length === 0) return null;

												return (
													<div key={sizeGroup} className={[s.section_group_items, s.section_group_items__size].join(' ')}>
														{ links }
													</div>
												);
											})
										}
									</div>
								</div>

								{/* colors */}
								<div className={s.section}>
									<div className={[s.section_group, (this.state.colors ? s.section_group__open : null)].join(' ')}>
										<a className={s.section_group_title} href="#open-group" data-group="colors" onClick={this.handleToggleGroup}>
											<span>{ translate(setup, 'filterColor') }</span>
											<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
											</svg>
										</a>
										<div className={[s.section_group_items, s.section_group_items__swatch].join(' ')}>
											{
												Object.keys(colors).sort((a, b) => {
													if (parseInt(colorDescriptions[a].order, 10) > parseInt(colorDescriptions[b].order, 10)) return 1;
													if (parseInt(colorDescriptions[a].order, 10) < parseInt(colorDescriptions[b].order, 10)) return -1;
													return 0;
												}).map((color) => {
													if (intersect(colors[color], relevantBaseProducts).length === 0) return null;

													const linkClasses = [s.section_group_item];
													const matches = intersect(colors[color], (lastFilter === 'colors' ? relevantFilterProductsLast : relevantFilterProducts)).length;
													if (matches === 0) linkClasses.push(s.section_group_item__disabled);
													if (filter.colors.indexOf(color) !== -1) linkClasses.push(s.section_group_item__selected);
													if (!colorDescriptions[color].image && colorDescriptions[color].color && lowContrast(colorDescriptions[color].color)) linkClasses.push(s.section_group_item__lowContrast);

													return (
														<a onClick={this.handleFilterUpdate} href={`#colors=${color}`} key={color} className={linkClasses.join(' ')}>
															{ colorDescriptions[color].image && <span style={{ backgroundImage: `url(${colorDescriptions[color].image.url})` }} /> }
															{ !colorDescriptions[color].image && <span style={{ backgroundColor: colorDescriptions[color].color }} /> }
															<span>{ colorDescriptions[color].description }</span>
															<span>{ `[${matches}]` }</span>
														</a>
													);
												})
											}
										</div>
									</div>
								</div>

								{/* materials */}
								{
									Object.keys(materials).filter((material) => intersect(materials[material], relevantBaseProducts).length > 0).length > 0 && (
										<div className={s.section}>
											<div className={[s.section_group, (this.state.materials ? s.section_group__open : null)].join(' ')}>
												<a className={s.section_group_title} href="#open-group" data-group="materials" onClick={this.handleToggleGroup}>
													<span>{ translate(setup, 'filterMaterial') }</span>
													<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
													</svg>
												</a>
												<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
													{
														Object.keys(materials).sort((a, b) => {
															if (parseInt(materialDescriptions[a].order, 10) > parseInt(materialDescriptions[b].order, 10)) return 1;
															if (parseInt(materialDescriptions[a].order, 10) < parseInt(materialDescriptions[b].order, 10)) return -1;
															return 0;
														}).map((material) => {
															const linkClasses = [s.section_group_item];
															if (intersect(materials[material], (lastFilter === 'materials' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
															if (filter.materials.indexOf(material) !== -1) linkClasses.push(s.section_group_item__selected);

															return (
																<div key={material} className={linkClasses.join(' ')}>
																	<a onClick={this.handleFilterUpdate} href={`#materials=${material}`}>
																		{ materialDescriptions[material].title }
																	</a>
																</div>
															);
														})
													}
												</div>
											</div>
										</div>
									)
								}

								{/* features */}
								{
									Object.keys(features).filter((feature) => intersect(features[feature], relevantBaseProducts).length > 0).length > 0 && (
										<div className={s.section}>
											<div className={[s.section_group, (this.state.features ? s.section_group__open : null)].join(' ')}>
												<a className={s.section_group_title} href="#open-group" data-group="features" onClick={this.handleToggleGroup}>
													<span>{ translate(setup, 'filterFeatures') }</span>
													<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
													</svg>
												</a>
												<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
													{
														Object.keys(features).sort((a, b) => {
															if (parseInt(featureDescriptions[a].order, 10) > parseInt(featureDescriptions[b].order, 10)) return 1;
															if (parseInt(featureDescriptions[a].order, 10) < parseInt(featureDescriptions[b].order, 10)) return -1;
															return 0;
														}).map((feature) => {
															const linkClasses = [s.section_group_item];
															if (intersect(features[feature], (lastFilter === 'features' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
															if (filter.features.indexOf(feature) !== -1) linkClasses.push(s.section_group_item__selected);

															return (
																<div key={feature} className={linkClasses.join(' ')}>
																	<a onClick={this.handleFilterUpdate} href={`#features=${feature}`}>
																		{ featureDescriptions[feature].title }
																	</a>
																</div>
															);
														})
													}
												</div>
											</div>
										</div>
									)
								}

								{/* collections */}
								{
									Object.keys(collections).filter((collection) => intersect(collections[collection], relevantBaseProducts).length > 0).length > 0 && (
										<div className={s.section}>
											<div className={[s.section_group, (this.state.collections ? s.section_group__open : null)].join(' ')}>
												<a className={s.section_group_title} href="#open-group" data-group="collections" onClick={this.handleToggleGroup}>
													<span>{ translate(setup, 'filterCollection') }</span>
													<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
													</svg>
												</a>
												<div className={[s.section_group_items, s.section_group_items__standard].join(' ')}>
													{
														Object.keys(collections).sort((a, b) => {
															if (parseInt(collectionDescriptions[a].order, 10) > parseInt(collectionDescriptions[b].order, 10)) return 1;
															if (parseInt(collectionDescriptions[a].order, 10) < parseInt(collectionDescriptions[b].order, 10)) return -1;
															return 0;
														}).map((collection) => {
															const linkClasses = [s.section_group_item];
															if (intersect(collections[collection], (lastFilter === 'collections' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.section_group_item__disabled);
															if (filter.collections.indexOf(collection) !== -1) linkClasses.push(s.section_group_item__selected);

															return (
																<div key={collection} className={linkClasses.join(' ')}>
																	<a onClick={this.handleFilterUpdate} href={`#collections=${collection}`}>
																		{ collectionDescriptions[collection].title }
																	</a>
																</div>
															);
														})
													}
												</div>
											</div>
										</div>
									)
								}

								{/* Prices */}
								<div className={s.section}>
									<div className={[s.section_group, (this.state.prices ? s.section_group__open : null)].join(' ')}>
										<a className={s.section_group_title} href="#open-group" data-group="prices" onClick={this.handleToggleGroup}>
											<span>{ translate(setup, 'filterPrices') }</span>
											<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M0 3.228L8.13034e-08 5.088L1.968 3.6L3.468 2.4L3.468 8.748H5.088L5.088 2.424L6.564 3.6L8.544 5.088V3.228L4.272 0L0 3.228Z" fill="black" />
											</svg>
										</a>
										<div className={[s.section_group_items, s.section_group_items__prices].join(' ')}>
											<RangeSlide values={currentPrices} labels={[[0, setup.currency === 'USD' ? '$' : '€'], ...priceMedians, [100, setup.currency === 'USD' ? '$$$' : '€€€']]} onChange={this.priceSlideHandler} initialLower={filter.price} />
										</div>
									</div>
								</div>

								{/* Toggle sale products */}
								{
									!hideSaleToggle && (
										<div className={[s.section_group, s.section_group__open].join(' ')}>
											<div className={[s.section_group_items, s.section_group_items__standard, s.section_group_items__boolean].join(' ')}>
												<div className={saleClasses.join(' ')}>
													<a onClick={this.handleFilterUpdate} href="#productsOnSale=1">
														{ translate(setup, 'filterIncludeSale') }
													</a>
												</div>
											</div>
										</div>
									)
								}

								{/* Apply / View */}
								<div className={s.section_totals}>
									<span className={s.section_totals_results}>{ translate(setup, 'filterTotalItems').replace('%amount%', relevantProducts.length) }</span>
									<a className={s.section_totals_apply} href="#view" onClick={this.resetFilterDropdowns}>
										<span>{ translate(setup, 'filterView') }</span>
									</a>
									<a className={s.section_totals_clear} href="#view" onClick={this.handleClearFilter}>
										<span>{ translate(setup, 'filterClear') }</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				{
					relevantProducts.length > 0 || filter.filteredBy.length === 1 ? (
						<div className={s.products}>
							<Pagination ListComponent={ListComponent} categoryTitle={(data?.content?.title || 'Search')} list={relevantProducts} cache={products} currentPath={prefix(setup, currentPath)} currentHash="" contentSections={contentSections} contentOffset={contentOffset} isFiltered={isFiltered} gridAmount={gridAmount} closeSearch={closeSearch} showingGhost={showingGhost} />
							{
								relevantProducts.length === 0 && (
									<div className={s.products_empty}>
										<h1 className={s.products_empty_title}>{ relevantBaseProducts.length > 0 ? translate(setup, 'filterNoResults') : translate(setup, 'filterNoResultsNoFilter') }</h1>
										{
											filter.filteredBy.map((filterObj) => (
												Object.keys(filterObj).map((filterKey) => {
													if (Array.isArray(filterObj[filterKey])) {
														return filterObj[filterKey].map((filterItem) => {
															let title = filterDescriptions[filterKey][filterItem];
															if (filterKey === 'colors') title = colorDescriptions[filterItem];
															if (filterKey === 'sizes') title = filterDescriptions[filterKey][filterItem.slice(filterItem.indexOf('___') + 3)];
															if (filterKey === 'categories') {
																let href = filterItem.split('/').slice(0, -1).join('/');
																title = filterDescriptions[filterKey][href];
																href = prefix(setup, href);
																return <Link to={href}>{ title }</Link>;
															}
															return <a className={s.filter_empty_link} href={`#${filterKey}=${filterItem}`} onClick={this.handleFilterUpdate}>{ title }</a>;
														});
													}
													return <a className={s.filter_empty_link} href={`#${filterKey}=1`} onClick={this.handleFilterUpdate}>{ translate(setup, `filter${filterKey.charAt(0).toUpperCase()}${filterKey.slice(1)}`) }</a>;
												})
											))
										}
									</div>
								)
							}
						</div>
					) : (
						<div className={s.filter_empty}>
							<h1 className={s.filter_empty_title}>{ relevantBaseProducts.length > 0 ? translate(setup, 'filterNoResults') : translate(setup, 'filterNoResultsNoFilter') }</h1>
							{
								filter.filteredBy.map((filterObj) => (
									Object.keys(filterObj).map((filterKey) => {
										if (filterKey === 'price' && filterObj[filterKey].length > 0) {
											return <a className={s.filter_empty_link} href={`#${filterKey}=0,100`} onClick={this.handleFilterUpdate}><span>{ `${currentPrices[Math.floor((currentPrices.length - 1) * (filterObj[filterKey][0] / 100))]} - ${currentPrices[Math.floor((currentPrices.length - 1) * (filterObj[filterKey][1] / 100))]}` }</span></a>;
										}
										if (Array.isArray(filterObj[filterKey])) {
											return filterObj[filterKey].map((filterItem) => {
												let title = filterDescriptions?.[filterKey]?.[filterItem] || '';
												if (filterKey === 'colors') title = colorDescriptions[filterItem].description;
												if (filterKey === 'sizes') title = filterDescriptions[filterKey][filterItem.slice(filterItem.indexOf('___') + 3)];
												if (filterKey === 'categories') {
													let href = filterItem.split('/').slice(0, -1).join('/');
													title = filterDescriptions[filterKey][href];
													href = prefix(setup, href);
													return <Link to={href}>{ title }</Link>;
												}
												return <a className={s.filter_empty_link} href={`#${filterKey}=${filterItem}`} onClick={this.handleFilterUpdate}><span>{ title?.title || title }</span></a>;
											});
										}
										return <a className={s.filter_empty_link} href={`#${filterKey}=1`} onClick={this.handleFilterUpdate}>{ translate(setup, `filter${filterKey.charAt(0).toUpperCase()}${filterKey.slice(1)}`) }</a>;
									})
								))
							}
						</div>
					)
				}
			</div>
		);
	}
}

const mapState = ({ filter }, props) => ({
	filter,
	...props,
});

export default hot(module)(connect(mapState, { updateFilter, resetFilter, clearFilter, updatePagination })(Filter));
